
import React from 'react';
import { TableCell } from '@/components/ui/table';
import { SubjectBadge } from './SubjectBadge';

interface GradeLevelSubjectsProps {
  subjects: Array<{
    subject: string;
    course_types: string[];
  }>;
}

export const GradeLevelSubjects: React.FC<GradeLevelSubjectsProps> = ({
  subjects,
}) => {
  return (
    <TableCell>
      <div className="space-y-1">
        {subjects.length > 0 ? (
          subjects.map((subject, index) => (
            <SubjectBadge
              key={index}
              subject={subject.subject}
              courseTypes={subject.course_types}
            />
          ))
        ) : (
          <span className="text-muted-foreground">-</span>
        )}
      </div>
    </TableCell>
  );
};
